const $ = sel => document.querySelector(sel);

// Live inventory stock-lookup endpoint. Do not point this at the dev-store endpoint
// (nn2kcb39qg) - it is not meant for the live site and times out (504, reported by
// the browser as a CORS error), which makes every pickup lookup return "Out of Stock".
const INVENTORY_ENDPOINT = 'https://sc1l9727g1.execute-api.ap-southeast-2.amazonaws.com/Prod/inventory/stock-lookup';
const normalize = txt => (txt || '').trim().toLowerCase();

function _pickupMsgBox() {
    const picker = typeof getPicker === 'function' ? getPicker() : null;
    const root = picker?.closest('section') || document;
    // Prefer the message box in the same section; fall back to the first one
    return root.querySelector('[id^="pickup-messages-"]')
        || document.querySelector('[id^="pickup-messages-"]');
  }

  function getMessageTemplates() {
    const box = _pickupMsgBox();
    return {
      in:  box?.querySelector('.in')?.textContent  || 'Size {size} Available to pick up in 4 hours',
      low: box?.querySelector('.low')?.textContent || 'Size {size} Low stock. Ready in 4h to be picked up in store',
      out: box?.querySelector('.out')?.textContent || 'Size {size} will be shipped to store. Pick up in 2-3 days',
    };
  }

  function normalizeStockLevel(level) {
    const s = (level || '').trim().toLowerCase();
    if (s === 'out of stock') return 'out';
    if (s === 'low stock') return 'low';
    return 'in'; // everything else = in stock
  }

  function composeAvailabilityMessage(level, sizeLabel) {
    const t = getMessageTemplates();
    switch (normalizeStockLevel(level)) {
      case 'out': return t.out.replace('{size}', sizeLabel);
      case 'low': return t.low.replace('{size}', sizeLabel);
      default:    return t.in.replace('{size}', sizeLabel);
    }
  }

const getPicker = () => $('delivery-picker');
const getForm = () => $('form[id^="product-form-"]');

const getSizeMap = () => {
    const el = $('#sku-size-map');
    return el ? JSON.parse(el.textContent) : {};
};

async function previewInventory(colour) {
    const picker = getPicker();
    if (!picker) return [];
    const stylecode = picker.dataset.stylecode;
    const url = INVENTORY_ENDPOINT
        + `?stylecode=${encodeURIComponent(stylecode)}`
        + `&colour=${encodeURIComponent(colour)}`;
    const json = await fetch(url).then(r => r.json()).catch(() => null);
    const locs = Array.isArray(json) ? json : json?.locations||[];
    inventoryCache[`${stylecode}|${colour}`] = locs;
    return locs;
}

function normalizeSizeLabel(value) {
    return (value || '').trim();
}

function getSizeOptionValues() {
    const fieldsets = Array.from(document.querySelectorAll('fieldset.variant-picker__option'));
    const sizeFieldset = fieldsets.find(fieldset => {
        const legend = fieldset.querySelector('legend');
        return legend && legend.textContent.trim().toLowerCase().includes('size');
    });

    if (!sizeFieldset) return [];

    const values = Array.from(sizeFieldset.querySelectorAll('label, a, button, span'))
        .map(el => el.textContent.trim())
        .filter((text, index, array) => text && array.indexOf(text) === index);

    return values;
}

function compareSizeLabels(a, b) {
    const labelA = normalizeSizeLabel(a);
    const labelB = normalizeSizeLabel(b);

    const numericPattern = /^[-+]?\d+(?:\.\d+)?$/;
    const numericA = numericPattern.test(labelA);
    const numericB = numericPattern.test(labelB);
    if (numericA && numericB) {
        return parseFloat(labelA) - parseFloat(labelB);
    }
    if (numericA) return -1;
    if (numericB) return 1;

    const order = getSizeOptionValues();
    if (order.length) {
        const idxA = order.indexOf(labelA);
        const idxB = order.indexOf(labelB);
        if (idxA !== -1 || idxB !== -1) {
            if (idxA === -1) return 1;
            if (idxB === -1) return -1;
            return idxA - idxB;
        }
    }

    return labelA.localeCompare(labelB, undefined, { numeric: true, sensitivity: 'base' });
}

function sortSkusBySizeLabel(skus, sizeMap) {
    return skus.slice().sort((a, b) => {
        const labelA = sizeMap[a] || a;
        const labelB = sizeMap[b] || b;
        return compareSizeLabels(labelA, labelB);
    });
}

function rebuildInventoryTables(locs, sizeMap) {
    const skus = sortSkusBySizeLabel(Array.from(new Set(
        locs.flatMap(loc => loc.inventory.map(i => i.sku))
    )), sizeMap);

    document.querySelectorAll('.store-inventory').forEach(table => {
        // HEADER
        const headRow = table.querySelector('thead tr');
        const bodyRow = table.querySelector('tbody tr');
        const storeKey = table.closest('.store')?.dataset.store;
        const loc = locs.find(l => normalize(l.name) === normalize(storeKey));
        headRow.innerHTML = skus
            .map(sku => {
                const label = sizeMap[sku] || sku;
                return `<th data-sku="${sku}" data-status="${label}">${label}</th>`;
            })
            .join('');

        bodyRow.innerHTML = skus
            .map(sku => {
                const inv = loc?.inventory.find(i => i.sku === sku);
                const stock = inv?.stockLevel || '—';
                const stockHandle   = stock.replace(/\s/g, '-').toLowerCase();
                const label = sizeMap[sku] || sku;
                return `<td data-sku="${sku}" data-store="${storeKey}" data-status="${label}" class="${stockHandle}">${stock}</td>`;
            })
            .join('');
    });
}

let variantMap = {};
document.addEventListener('DOMContentLoaded', () => {
    const mapEl = document.getElementById('variant-id-sku-map');
    if (mapEl) variantMap = JSON.parse(mapEl.textContent);
});

const inventoryCache = Object.create(null);

const LS_STORE = () => {
    const h = getPicker()?.dataset.handle || 'unknown';
    return `pickupStore:handle:${h}`;
};
const LS_STOCK = () => {
    const p = getPicker();
    const h = p?.dataset.handle  || 'unknown';
    const s = p?.dataset.variantSku || 'unknown';
    return `pickupStock:${h}:${s}`;
};

async function setCartAttributes(obj) {
    await fetch('/cart/update.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ attributes: obj }),
    });
}

// Map of "<shopify location name lowercased>": "<numeric location id>", emitted by
// pickup-popup.liquid. Read lazily (the script can load before the DOM). Empty on
// pages that don't render the picker (e.g. cart), where the location id is read
// back from the _pickupLocationId cart attribute instead.
let _storeLocationIds = null;
function getStoreLocationIds() {
    if (_storeLocationIds) return _storeLocationIds;
    const el = document.getElementById('store-location-ids');
    try { _storeLocationIds = el ? JSON.parse(el.textContent) : {}; }
    catch { _storeLocationIds = {}; }
    return _storeLocationIds;
}

function locationIdForStore(storeName) {
    const map = getStoreLocationIds();
    const key = normalize(storeName);
    if (map[key]) return map[key];
    // Tolerate prefix/suffix differences between the metaobject store name and the
    // Shopify location name (e.g. "Max Albany" vs "Albany").
    for (const locName in map) {
        if (key.includes(locName) || locName.includes(key)) return map[locName];
    }
    return '';
}

// Mirror the buyer's PDP choice into Shopify's native cart delivery preference so
// checkout opens on the right tab (Ship/Pickup). Uses the tokenless Storefront
// Cart API; the storefront cart id is derived from the AJAX cart token. Failures
// are swallowed - this must never block add-to-cart or checkout.
async function syncDeliveryPreference(method, locationId) {
    try {
        const cart = await fetch('/cart.js').then(r => r.json());
        if (!cart || !cart.token) return;

        const delivery = { deliveryMethod: [method] };
        if (method === 'PICK_UP') {
            if (!locationId) return;
            delivery.pickupHandle = [String(locationId)];
        }

        const cartId   = `gid://shopify/Cart/${cart.token}`;
        const endpoint = `${window.location.origin}/api/2025-01/graphql.json`;

        const query = `mutation($cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!) {
            cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) {
                cart {
                    id
                    buyerIdentity {
                        countryCode
                        preferences { delivery { deliveryMethod pickupHandle } }
                    }
                }
                userErrors { field message code }
            }
        }`;

        const res = await fetch(endpoint, {
            method:  'POST',
            headers: { 'Content-Type': 'application/json' },
            // keepalive lets the request finish even if the page navigates
            // (add-to-cart / checkout) right after selection - callers fire this
            // without awaiting, so without keepalive the POST is aborted on unload.
            keepalive: true,
            body: JSON.stringify({
                query,
                variables: {
                    cartId,
                    buyerIdentity: { preferences: { delivery } },
                },
            }),
        });
        // Drain the response body so the connection is released back to the pool.
        // An unread fetch response keeps its connection open; firing this repeatedly
        // then exhausts the per-host connection limit (~6 in Chrome), and later
        // same-host requests (e.g. /cart/change.js) stall until a page refresh.
        await res.text().catch(() => {});
    } catch (e) {
        // Swallow: never block add-to-cart or checkout on a preference-sync error.
    }
}

async function getInventory(stylecode, colour) {
    const key = `${stylecode}|${colour}`;
    if (inventoryCache[key]) return inventoryCache[key];

    const url = INVENTORY_ENDPOINT
        + `?stylecode=${encodeURIComponent(stylecode)}`
        + `&colour=${encodeURIComponent(colour)}`;

    const json = await fetch(url).then(r => r.json()).catch(() => null);
    const locations = Array.isArray(json) ? json : json?.locations || [];

    inventoryCache[key] = locations;
    return locations;
}

function getStockLevel(sku, storeName, stylecode, colour) {
    const key = `${stylecode}|${colour}`;
    const locs = inventoryCache[key] || [];
  
    // Match directly without resolving store names
    const loc = locs.find(
      l => normalize(l.name) === normalize(storeName)
    );
  
    if (!loc) {
      console.warn("[getStockLevel] No location matched", {
        storeName,
        apiNames: locs.map(l => l.name)
      });
      return 'Out of Stock';
    }
  
    const inv = loc.inventory.find(i => i.sku === sku);
    return inv?.stockLevel || 'Out of Stock';
  }
  

document.addEventListener('DOMContentLoaded', () => {
    initPickupLogic().catch(console.error);
});

async function initPickupLogic() {
    const picker = getPicker();

    const cart = await fetch('/cart.js').then(r => r.json());

    const checkoutLoc = cart.attributes?._checkoutLocation || '';
    const currentAttrStore = cart.attributes?._storeName || '';
    const showAll = '_showAllLocations' in (cart.attributes || {});

    let actualStore   = checkoutLoc || currentAttrStore;
    const needResync  = checkoutLoc && normalize(checkoutLoc) !== normalize(currentAttrStore);

    if (needResync) {

        localStorage.setItem(LS_STORE(), checkoutLoc);

        await updateAllStockLevels(checkoutLoc);

        console.log('Setting cart attributes for store:', checkoutLoc);
        await setCartAttributes({
            _storeName:        checkoutLoc,
            _deliveryType:     'Pickup',
            _showAllLocations: ''
        });

    } else if (showAll) {
        await setCartAttributes({ _showAllLocations: '' });
    }

    if (picker && actualStore) {
        await getInventory(picker.dataset.stylecode, picker.dataset.colour);
        applyStoreSelection(actualStore);
    } else {
        prepareFormProperties('Ship it to me');
        // applyStoreSelection did not run (no picker, e.g. cart page, or no
        // selection). Mirror the persisted choice into the native checkout
        // delivery preference from cart attributes.
        if (cart.token) {
            if (cart.attributes?._deliveryType === 'Pickup') {
                const locId = cart.attributes._pickupLocationId
                    || locationIdForStore(actualStore);
                syncDeliveryPreference('PICK_UP', locId);
            } else {
                syncDeliveryPreference('SHIPPING');
            }
        }
    }

    await ensureLinesOnPickup(actualStore);
}

async function ensureLinesOnPickup(storeName) {
    const cart = await fetch('/cart.js').then(r => r.json());

    if (cart.attributes?._deliveryType !== 'Pickup') return;

    const needFix = cart.items.some(
        i => (i.properties?._delivery_method || 'Ship it to me') !== 'Pick up in-store'
    );
    if (!needFix) return;

    await updateAllExistingDelivery('Pick up in-store', storeName);
}

function buildColourSelector() {
    const regionSel = document.getElementById('region-select');
    if (!regionSel) return;

    document.getElementById('colour-select')?.remove();

    const swatches = Array.from(document.querySelectorAll('.product-info__product-picker .color-swatch'));
    if (!swatches.length) return;

    const sel = document.createElement('select');
    sel.id = 'colour-select';
    sel.className = 'colour-select ml-2';

    swatches.forEach(a => {
        const colour = a.querySelector('span')?.textContent.trim();
        if (!colour) return;
        const opt = document.createElement('option');
        opt.value = colour;
        opt.textContent = colour;
        if (a.classList.contains('is-selected')) opt.selected = true;
        sel.appendChild(opt);
    });

    regionSel.insertAdjacentElement('afterend', sel);
}

window.checkStoreAvailability = openAvailability;

function openAvailability(btn) {
    const picker = getPicker();
    if (!btn || !picker) return;
    const productInfo = btn.closest('.product-info');
    if (productInfo && productInfo.classList.contains('require-choose-size')) {
        const sizeMessage = productInfo.querySelector('.variant-picker__size-message');
        if (sizeMessage) {
            sizeMessage.textContent = 'Please select a size';
            sizeMessage.style.display = 'block';
            sizeMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
    }

    btn.disabled = true;
    btn.classList.add('is-loading');

    const pending = picker.dataset.pendingColour;
    const colourToUse = pending || picker.dataset.colour;

    previewInventory(colourToUse)
        .then(locs => {
            if (pending) {
                const swatchLink = Array.from(
                    document.querySelectorAll('.product-info__product-picker .color-swatch')
                ).find(a => a.querySelector('span')?.textContent.trim() === pending);

                if (swatchLink) {
                    return fetch(swatchLink.href)
                        .then(r => r.text())
                        .then(html => {
                            const doc   = new DOMParser().parseFromString(html, 'text/html');
                            const mapEl = doc.getElementById('sku-size-map');
                            const newMap = mapEl ? JSON.parse(mapEl.textContent) : getSizeMap();
                            return { locs, sizeMap: newMap };
                        });
                }
            }

            return { locs, sizeMap: getSizeMap() };
        })
        .then(({ locs, sizeMap }) => {

            rebuildInventoryTables(locs, sizeMap);

            buildPopup(locs);

            if (!document.getElementById('colour-select')) {
                buildColourSelector();
            }
        })
        .catch(err => {
            console.error('Availability Load Error:', err);
            const pop = $('#storeAvailabilityPopup .popup-slideout');
            if (pop) {
                pop.querySelector('.store-list').innerHTML =
                    '<p class="text-red-600">Failed to load availability.</p>';
                $('#storeAvailabilityPopup')?.classList.remove('hidden');
            }
        })
        .finally(() => {
            btn.disabled = false;
            btn.classList.remove('is-loading');
        });
}
window.closePopup = () => $('#storeAvailabilityPopup')?.classList.add('hidden');

document.addEventListener('change', e => {
    if (e.target.id !== 'region-select') return;
    const region = e.target.value;
    document
        .querySelectorAll('#storeAvailabilityPopup .store')
        .forEach(storeCard => {
            storeCard.style.display =
                !region || storeCard.dataset.region === region
                    ? 'flex'
                    : 'none';
        });
});
document.addEventListener('change', e => {
    if (e.target.id !== 'colour-select') return;
    const picker    = getPicker();
    const newColour = e.target.value;
    const loader    = document.getElementById('popup‐loader');
    if (!picker) return;

    loader.classList.remove('hidden');

    picker.dataset.pendingColour = newColour;
    document.getElementById('region-select').value = '';

    previewInventory(newColour)
        .then(locs => {

            const swatchLink = Array.from(
                document.querySelectorAll('.product-info__product-picker .color-swatch')
            ).find(a => a.querySelector('span')?.textContent.trim() === newColour);

            if (!swatchLink) {
                const currentMap = getSizeMap();
                rebuildInventoryTables(locs, currentMap);
                updateStockLevels(locs);
                updateAvailabilityBadge(localStorage.getItem(LS_STORE()), picker.dataset.variantSku);
                return;
            }

            fetch(swatchLink.href)
                .then(r => r.text())
                .then(html => {
                    const doc   = new DOMParser().parseFromString(html, 'text/html');
                    const mapEl = doc.getElementById('sku-size-map');
                    const newMap = mapEl ? JSON.parse(mapEl.textContent) : {};

                    rebuildInventoryTables(locs, newMap);

                    const popup = document.getElementById('storeAvailabilityPopup');
                    popup.querySelectorAll('.store').forEach(c => c.style.display = 'none');
                    locs.forEach(loc => {
                        const card = popup.querySelector(
                            `.store[data-store="${normalize(loc.name)}"]`
                        );
                        if (card) card.style.display = 'flex';
                    });

                    const saved = localStorage.getItem(LS_STORE());
                    if (saved) {
                        updateAvailabilityBadge(saved, picker.dataset.variantSku);
                    }
                })
                .catch(console.error);
        })
        .catch(console.error)
        .finally(() => {

            loader.classList.add('hidden');
        });

    const regionSel = document.getElementById('region-select');
    if (regionSel) {
        regionSel.dispatchEvent(new Event('change', { bubbles: true }));
    }

    return;
});

document.addEventListener('change', e => {
    if (e.target.name !== 'delivery-method') return;

    if (e.target.id === 'ship-it-to-me') {
        clearStoreSelection();
        return;
    }

    if (e.target.id === 'pick-up-in-store') {
        const saved  = localStorage.getItem(LS_STORE());
        const picker = getPicker();
        if (!saved || !picker) return;

        getInventory(picker.dataset.stylecode, picker.dataset.colour)
            .then(() => applyStoreSelection(saved))
            .catch(console.error);
    }
});

document.addEventListener('change', e => {
    if (e.target.type !== 'radio' || !e.target.closest('variant-picker')) return;

    const sku = e.target.dataset.variantSku;
    if (!sku) return;
    const sizeLabel = getSizeMap()[sku] || sku;
    const picker = getPicker();
    picker.dataset.variantSku = sku;

    const saved = localStorage.getItem(LS_STORE());
    if (saved && inventoryCache) updateAvailabilityBadge(saved, sku);

    if (e.target.name === 'delivery-method' && e.target.id === 'pick-up-in-store') {
        const saved = localStorage.getItem(LS_STORE());
        const picker = getPicker();
        if (saved && picker) {
            getInventory(picker.dataset.stylecode, picker.dataset.colour)
                .then(() => applyStoreSelection(saved))
                .catch(console.error);
        }
    }

    const badge = getPicker().querySelector('.selected-store');
    if (!badge) return;

    // Update .store-size-info with both size and availability
    const style = picker.dataset.stylecode;
    const colour = picker.dataset.colour;
    const level = getStockLevel(sku, saved, style, colour);
    let infoSpan = badge.querySelector('.store-size-info');
    if (!infoSpan) {
        infoSpan = document.createElement('span');
        infoSpan.className = 'store-size-info';
        badge.appendChild(infoSpan);
    }
    infoSpan.textContent = composeAvailabilityMessage(level, sizeLabel);
});

function updateAvailabilityBadge(storeName, sku) {
    const picker = getPicker();
    if (!picker) return;

    const badge = picker.querySelector('.selected-store');
    if (!badge) return;

    const sizeMap = getSizeMap();
    const sizeLabel = sizeMap[sku] || sku;
    const level = getStockLevel(
        sku,
        storeName,
        picker.dataset.stylecode,
        picker.dataset.colour,
    );

    let infoSpan = badge.querySelector('.store-size-info');
    if (!infoSpan) {
        infoSpan = document.createElement('span');
        infoSpan.className = 'store-size-info';
        badge.appendChild(infoSpan);
    }
    infoSpan.textContent = composeAvailabilityMessage(level, sizeLabel);


    localStorage.setItem(LS_STOCK(), level);

    const form = getForm();
    if (form) {
        removeProp(form, '_stockLevel');
        setProp(form, '_stockLevel', level);
    }
}

function buildPopup(locs) {
    $('#storeAvailabilityPopup')?.classList.remove('hidden');
    document.querySelectorAll('.store').forEach(el => el.style.display = 'none');
    locs.forEach(loc => {
        const card = $(`.store[data-store="${normalize(loc.name)}"]`);
        if (card) card.style.display = 'flex';
    });
    $('#region-select').value = '';
    updateStockLevels(locs);

    const saved = localStorage.getItem(LS_STORE());
    document.querySelectorAll('#storeAvailabilityPopup .select-store')
        .forEach(btn => btn.classList.toggle(
            'selected',
            btn.dataset.storeName === saved
        ));
}

async function updateStockLevels(locs) {
    const picker = getPicker();

    const sel = document.getElementById('colour-select');
    const popupColour = sel?.value;
    let sizeMap = getSizeMap();

    if (popupColour && popupColour !== picker.dataset.colour) {

        await previewInventory(popupColour);

        const swatchLink = Array.from(
            document.querySelectorAll('.product-info__product-picker .color-swatch')
        ).find(a => a.querySelector('span')?.textContent.trim() === popupColour);

        if (swatchLink) {
            try {
                const html = await fetch(swatchLink.href).then(r => r.text());
                const doc  = new DOMParser().parseFromString(html, 'text/html');
                const mapEl = doc.getElementById('sku-size-map');
                if (mapEl) sizeMap = JSON.parse(mapEl.textContent);
            } catch (err) {
                console.error('Failed to update sizeMap for', popupColour, err);

            }
        }
    }

    locs.forEach(loc => {
        loc.inventory.forEach(({ sku, stockLevel }) => {
            const cell = $(`td[data-sku="${sku}"][data-store="${normalize(loc.name)}"]`);
            if (!cell) return;
            cell.textContent = stockLevel;
            cell.className   = stockLevel.replace(/\s/g, '-').toLowerCase();

            const th = cell.closest('table').querySelector(`th[data-sku="${sku}"]`);
            if (th) th.textContent = sizeMap[sku] || sku;
        });
    });
}

document.addEventListener('click', e => {
    if (!e.target.classList.contains('select-store')) return;
    const btns = document.querySelectorAll('#storeAvailabilityPopup .select-store');
    btns.forEach(b => b.classList.remove('selected'));
    e.target.classList.add('selected');
    const picker   = getPicker();
    const pending  = picker?.dataset.pendingColour;
    const store    = e.target.dataset.storeName;

    if (pending && pending !== picker.dataset.colour) {
        const swatchLink = Array.from(
            document.querySelectorAll('.product-info__product-picker .color-swatch')
        ).find(a => a.querySelector('span')?.textContent.trim() === pending);
        if (swatchLink) {
            const currentSku  = picker.dataset.variantSku;
            const sizeLabel   = getSizeMap()[currentSku];
            localStorage.setItem(LS_STORE(), store);
            localStorage.setItem(LS_STOCK(), getStockLevel(picker.dataset.variantSku, store, picker.dataset.stylecode, pending));
            fetch(swatchLink.href)
                .then(r => r.text())
                .then(html => {
                    const doc = new DOMParser().parseFromString(html, 'text/html');
                    const newSizeMapEl = doc.getElementById('sku-size-map');
                    const newSizeMap= newSizeMapEl ? JSON.parse(newSizeMapEl.textContent) : {};

                    const newVarMapEl  = doc.getElementById('variant-id-sku-map');
                    const newVarMap    = newVarMapEl ? JSON.parse(newVarMapEl.textContent) : {};

                    const skuToId = Object.fromEntries(
                        Object.entries(newVarMap).map(([id, sku]) => [sku, id])
                    );

                    const newSku = Object.entries(newSizeMap)
                        .find(([, label]) => label === sizeLabel)?.[0];

                    let url = swatchLink.href;
                    if (newSku && skuToId[newSku]) {
                        const vid = skuToId[newSku];
                        const sep = url.includes('?') ? '&' : '?';
                        url = url + sep + 'variant=' + vid;
                    }

                    picker.dataset.colour = pending;
                    window.location.href = url;
                })
                .catch(err => {
                    console.error('Redirect error:', err);

                    picker.dataset.colour = pending;
                    window.location.href = swatchLink.href;
                });
            return;
        }
    }

    applyStoreSelection(store);
    closePopup();
});

// Prevent form submit as a fallback when user tries to add to cart
// with pickup selected but no store chosen. Uses capture to run
// before other submit handlers and reliably stop the submission.
document.addEventListener('submit', function(e) {
    const form = e.target;
    if (!form || !form.matches('form[id^="product-form-"]')) return;

    const wantsPickup = !!document.getElementById('pick-up-in-store')?.checked;
    const pickedStore = localStorage.getItem(LS_STORE());
    if (wantsPickup && !pickedStore) {
        e.preventDefault();
        showStoreError();
    }
}, true);

// Capture click events on add-to-cart buttons to stop other click handlers
// (and inline onclicks) from proceeding when pickup is selected but no store.
document.addEventListener('click', function(e) {
    const btn = e.target.closest('button[type="submit"]');
    if (!btn) return;
    const form = getForm();
    if (!form || btn.form !== form) return;

    const wantsPickup = !!document.getElementById('pick-up-in-store')?.checked;
    const pickedStore = localStorage.getItem(LS_STORE());
    if (wantsPickup && !pickedStore) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showStoreError();
        return false;
    }
}, true);

// Protect against code that calls form.submit() programmatically
// (which does not fire submit listeners). We wrap the native submit.
if (typeof HTMLFormElement !== 'undefined') {
    const _nativeSubmit = HTMLFormElement.prototype.submit;
    HTMLFormElement.prototype.submit = function() {
        try {
            if (this.matches && this.matches('form[id^="product-form-"]')) {
                const wantsPickup = !!document.getElementById('pick-up-in-store')?.checked;
                const pickedStore = localStorage.getItem(LS_STORE());
                if (wantsPickup && !pickedStore) {
                    showStoreError();
                    return;
                }
            }
        } catch (err) {
            console.error('submit wrapper error', err);
        }
        return _nativeSubmit.apply(this, arguments);
    };
}

let skipNextClick = false;
document.addEventListener('click', async e => {
    const btn  = e.target.closest('button[type="submit"]');
    if (!btn) return;
    // Validate against the clicked button's OWN form. The PDP renders two product
    // forms (main + sticky), so a global getForm() can return the other one and
    // the guard would skip validation for the button actually clicked. Read the id
    // via getAttribute: the form has an <input name="id"> that clobbers form.id.
    const form = btn.form;
    if (!form || !(form.getAttribute('id') || '').startsWith('product-form-')) return;
    if (skipNextClick) { skipNextClick = false; return; }

    e.preventDefault();

    const wantsPickup = !!$('#pick-up-in-store')?.checked;
    const pickedStore = localStorage.getItem(LS_STORE());
    if (wantsPickup && !pickedStore) {
        showStoreError();
        return;
    }

    const intended    = wantsPickup ? 'Pick up in-store' : 'Ship it to me';
    const intendedAttr= wantsPickup ? 'Pickup' : 'Shipping';

    const cart = await fetch('/cart.js').then(r => r.json());
    const currentAttr   = cart.attributes?._deliveryType || 'Shipping';
    const firstItem     = cart.items.find(i => i.properties?._delivery_method);
    const currentMethod = firstItem?.properties._delivery_method || null;

    const confirmAndGo = async () => {
        await updateAllExistingDelivery(intended);
        await setCartAttributes({
            _deliveryType: intendedAttr,
            _storeName:    wantsPickup ? (localStorage.getItem(LS_STORE()) || '') : '',
            _checkoutLocation: wantsPickup ? (localStorage.getItem(LS_STORE()) || '') : '',
            _pickupLocationId: wantsPickup ? locationIdForStore(pickedStore) : '',
        });
        prepareFormProperties(intended, form);
        skipNextClick = true;
        setTimeout(() => btn.click(), 0);
    };

    if (currentAttr !== intendedAttr || (currentMethod && currentMethod !== intended)) {
        showSwitchModal(currentMethod ?? currentAttr, intended, confirmAndGo);
    } else {
        prepareFormProperties(intended, form);
        await setCartAttributes({
            _deliveryType: intendedAttr,
            _storeName:    wantsPickup ? (localStorage.getItem(LS_STORE()) || '') : '',
            _checkoutLocation: wantsPickup ? pickedStore : '',
            _pickupLocationId: wantsPickup ? locationIdForStore(pickedStore) : ''
        });
        skipNextClick = true;
        setTimeout(() => btn.click(), 0);
    }
});

// Sync the delivery preference into the cart buyer identity right before leaving
// for checkout (cart drawer or cart page). initPickupLogic only runs on page load,
// so a drawer -> checkout jump would otherwise carry a stale/empty preference and
// checkout would not preselect. Awaited so the mutation commits before navigation.
let _skipCheckoutClick = false;
document.addEventListener('click', async e => {
    const btn = e.target.closest('[name="checkout"]');
    if (!btn) return;
    const form = btn.form || btn.closest('form');
    if (!form) return;
    if (_skipCheckoutClick) { _skipCheckoutClick = false; return; }

    e.preventDefault();
    try {
        const cart = await fetch('/cart.js').then(r => r.json());
        if (cart?.token) {
            if (cart.attributes?._deliveryType === 'Pickup') {
                await syncDeliveryPreference('PICK_UP', cart.attributes._pickupLocationId || '');
            } else {
                await syncDeliveryPreference('SHIPPING');
            }
        }
    } catch (err) {
        // Swallow: never block checkout on a preference-sync error.
    }
    _skipCheckoutClick = true;
    btn.click();
});

// Sync the native cart delivery preference as soon as an item is added, using
// the cart attributes the ATC handler just committed. This is the reliable
// moment: the cart now has a token + the item. theme.js dispatches variant:add
// after /cart/add.js succeeds (detail.cart is a fresh /cart.js).
document.addEventListener('variant:add', (e) => {
    const attrs = e.detail?.cart?.attributes || {};
    if (attrs._deliveryType === 'Pickup') {
        const locId = attrs._pickupLocationId || locationIdForStore(attrs._storeName || '');
        syncDeliveryPreference('PICK_UP', locId);
    } else {
        syncDeliveryPreference('SHIPPING');
    }
});

function showStoreError() {
    const picker = getPicker();
    if (!picker) return;

    if (picker.querySelector('.store-error')) return;

    const p = document.createElement('p');
    p.className = 'store-error mt-1 text-sm text-red-600';
    p.textContent = 'Please select store.';
    picker.querySelector('.pickup .block-swatch').appendChild(p);

    const remove = () => { p.remove(); document.removeEventListener('store-picked', remove); clearTimeout(timeoutId);};
    document.addEventListener('store-picked', remove);

    const timeoutId = setTimeout(remove, 10000);
}

function applyStoreSelection(storeName) {
    const picker = getPicker();
    const form   = getForm();
    if (!picker || !form) return;

    $('#pick-up-in-store')?.click();

    let badge = picker.querySelector('.selected-store');
    if (!badge) {
        badge = document.createElement('span');
        badge.className = 'selected-store mt-2 text-sm';
        picker.querySelector('.pickup label').appendChild(badge);
    } else {
        badge.replaceChildren();
    }

    const sku = picker.dataset.variantSku;
    const sizeMap  = getSizeMap();
    const sizeLabel = sizeMap[sku] || sku;

    const storeSpan = document.createElement('span');
    storeSpan.textContent = storeName;
    badge.appendChild(storeSpan);

    // Find or create .store-size-info and update its text
    const style    = picker.dataset.stylecode;
    const colour   = picker.dataset.colour;
    const level    = getStockLevel(sku, storeName, style, colour);

    let infoSpan = badge.querySelector('.store-size-info');
    if (!infoSpan) {
        infoSpan = document.createElement('span');
        infoSpan.className = 'store-size-info';
        badge.appendChild(infoSpan);
    }
    infoSpan.textContent = composeAvailabilityMessage(level, sizeLabel);


    localStorage.setItem(LS_STORE(), storeName);
    localStorage.setItem(LS_STOCK(), level);

    setProp(form, '_delivery_method', 'Pick up in-store');
    setProp(form, '_stockLevel',      level);
    setProp(form, '_stylecode',       style);
    setProp(form, '_colour',          colour);

    updateAllStoreName(storeName).catch(console.error);
    updateAllStockLevels(storeName).catch(console.error);

    const locationId = locationIdForStore(storeName);
    setCartAttributes({
        _deliveryType: 'Pickup',
        _storeName: storeName,
        _checkoutLocation: storeName,
        _pickupLocationId: locationId
    }).catch(console.error);
    syncDeliveryPreference('PICK_UP', locationId);

    document.dispatchEvent(new Event('store-picked'));
}

function clearStoreSelection() {
    const picker = getPicker();
    const form   = getForm();
    picker?.querySelector('.selected-store')?.remove();

    removeProp(form, '_delivery_method');
    removeProp(form, '_store_name');
    removeProp(form, '_stockLevel');

    setProp(form, '_delivery_method', 'Ship it to me');

    localStorage.removeItem(LS_STORE());
    localStorage.removeItem(LS_STOCK());

    setCartAttributes({
        _deliveryType: 'Shipping',
        _storeName:    '',
        _checkoutLocation: '',
        _pickupLocationId: '',

    }).catch(console.error);
    syncDeliveryPreference('SHIPPING');
}

async function updateAllExistingDelivery(newMethod, storeName = '') {
    const cart = await fetch('/cart.js').then(r => r.json());
    if (!cart.items.length) return;

    if (!storeName) storeName = localStorage.getItem(LS_STORE()) || '';

    for (let i = 0; i < cart.items.length; i++) {
        const item    = cart.items[i];
        const current = item.properties?._delivery_method || 'Ship it to me';
        if (current === newMethod) continue;

        const props = { ...item.properties, _delivery_method: newMethod };
        if (newMethod === 'Pick up in-store') {
            props._stockLevel  = getStockLevel(
                item.sku,
                storeName,
                item.properties._stylecode,
                item.properties._colour,
            );
        } else {
            delete props._store_name;
            delete props._stockLevel;
        }

        await fetch('/cart/change.js', {
            method:'POST',
            headers:{ 'Content-Type':'application/json' },
            body: JSON.stringify({ line: i + 1, quantity: item.quantity, properties: props }),
        });
    }

    await setCartAttributes({
        _deliveryType: newMethod === 'Pick up in-store' ? 'Pickup' : 'Shipping',
        _storeName:    newMethod === 'Pick up in-store' ? storeName : '',
        _checkoutLocation:    newMethod === 'Pick up in-store' ? storeName : '',
    });

    if (newMethod === 'Pick up in-store') await updateAllStockLevels(storeName);
}

async function updateAllStoreName(newStore) {
    const cart = await fetch('/cart.js').then(r => r.json());
    if (!cart.items.length) return;

    for (let i = 0; i < cart.items.length; i++) {
        const item   = cart.items[i];
        const method = item.properties?._delivery_method || 'Ship it to me';
        if (method !== 'Pick up in-store') continue;

        const props = {
            ...item.properties,
            _delivery_method: method,
            _stockLevel:      getStockLevel(
                item.sku,
                newStore,
                item.properties._stylecode,
                item.properties._colour,
            ),
        };

        await fetch('/cart/change.js', {
            method:'POST',
            headers:{ 'Content-Type':'application/json' },
            body: JSON.stringify({ line: i + 1, quantity: item.quantity, properties: props }),
        });
    }
}

async function updateAllStockLevels(storeName) {
    const cart = await fetch('/cart.js').then(r => r.json());
    if (!cart.items.length) return;

    const needed = {};
    cart.items.forEach(item => {
        const method = item.properties?._delivery_method || 'Ship it to me';
        if (method !== 'Pick up in-store') return;
        const sc = item.properties._stylecode;
        const cl = item.properties._colour;
        if (sc && cl && !inventoryCache[`${sc}|${cl}`]) {
            needed[`${sc}|${cl}`] = { sc, cl };
        }
    });
    await Promise.all(
        Object.values(needed).map(({ sc, cl }) => getInventory(sc, cl)),
    );

    for (let i = 0; i < cart.items.length; i++) {
        const item   = cart.items[i];
        const method = item.properties?._delivery_method || 'Ship it to me';
        if (method !== 'Pick up in-store') continue;

        const level = getStockLevel(
            item.sku,
            storeName,
            item.properties._stylecode,
            item.properties._colour,
        );
        if (level === item.properties?._stockLevel) continue;

        await fetch('/cart/change.js', {
            method:'POST',
            headers:{ 'Content-Type':'application/json' },
            body: JSON.stringify({
                line: i + 1,
                quantity: item.quantity,
                properties: { ...item.properties, _stockLevel: level },
            }),
        });
    }
}

function setProp(form, label, value) {
    const name = `properties[${label}]`;
    let inp = form.querySelector(`[name="${name}"]`);
    if (!inp) {
        inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = name;
        form.appendChild(inp);
    }
    inp.value = value;
}
function removeProp(form, label) {
    form.querySelector(`[name="properties[${label}]"]`)?.remove();
}

function prepareFormProperties(method, form = getForm()) {
    if (!form) return;

    removeProp(form, '_delivery_method');
    removeProp(form, '_store_name');
    removeProp(form, '_stockLevel');

    setProp(form, '_delivery_method', method);

    const picker = getPicker();
    const style  = picker?.dataset.stylecode;
    const colour = picker?.dataset.colour;

    setProp(form, '_stylecode', style || '');
    setProp(form, '_colour',    colour || '');

    if (method === 'Pick up in-store') {

        const lvl   = localStorage.getItem(LS_STOCK()) || 'Out of Stock';
        setProp(form, '_stockLevel', lvl);
    }
}

function showSwitchModal(from, to, onYes) {
    const modal = $('#switch-delivery-modal');
    modal.querySelector('[data-role="modalNotSelectedShippingMethod"]').textContent = `'${from}'`;
    modal.querySelector('[data-role="modalSelectedShippingMethod"]').textContent   = `'${to}'`;
    modal.classList.add('_show');
    modal.querySelector('.confirm').onclick = () => { modal.classList.remove('_show'); onYes(); };
    modal.querySelector('.delivery').onclick = () => modal.classList.remove('_show');
    modal.querySelector('.action-close').onclick = () => modal.classList.remove('_show');

}